<template>
  <base-index
    ref="baseIndex"
    :columns="columns"
    :resourceName="resourceName"
    :pk="pk"
    :disabledFilterButton="false"
    :breadcrumbs="breadcrumbs"
  >
  </base-index>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      resourceName: "administrators",
      pk: "id",
      columns: [
        {
          value: "id",
          text: "運営管理者ID",
          filter: true,
          width: '80px'
        },
        {
          value: "email",
          text: "メールアドレス",
          filter: true,
          width: 80
        },
        {
          value: "name",
          text: "運営管理者名",
          filter: true,
          width: 80
        },
        {
          value: "permission_all",
          text: "全権限",
          filter: true,
          width: 80,
          type: 'select',
          optionType: "common/permissions"
        },
        {
          value: "permission_maker",
          text: "メーカー管理権限",
          filter: true,
          width: 80,
          type: 'select',
          optionType: "common/other_permissions"
        },
        {
          value: "permission_user",
          text: "ユーザ管理権限",
          filter: true,
          width: 80,
          type: 'select',
          optionType: "common/other_permissions"
        },
        {
          value: "permission_article",
          text: "特集記事管理権限",
          filter: true,
          width: 80,
          type: 'select',
          optionType: "common/other_permissions"
        },
        {
          value: "deleted",
          text: "削除ステータス",
          filter: true,
          width: 80,
          type: 'select',
          optionType: "common/delete_status"
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "運営管理者一覧",
          disabled: true
        }
      ];
    }
  }
};
</script>
